// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11WG2","colBig":"styles_colBig__1ZVdW","colSmall":"styles_colSmall__3HR_m"};